import { render, staticRenderFns } from "./CmgNewHero.vue?vue&type=template&id=52c1c571&scoped=true&lang=pug"
import script from "./cmg-new-hero.ts?vue&type=script&lang=ts&external"
export * from "./cmg-new-hero.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNewHero.vue?vue&type=style&index=0&id=52c1c571&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1c571",
  null
  
)

export default component.exports